module.exports = __webpack_public_path__ + "img/20220624172647.d5fbde73.png";